import { render, staticRenderFns } from "./service-course-badge.vue?vue&type=template&id=cb9536e4&scoped=true"
import script from "./service-course-badge.vue?vue&type=script&lang=js"
export * from "./service-course-badge.vue?vue&type=script&lang=js"
import style0 from "./service-course-badge.vue?vue&type=style&index=0&id=cb9536e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9536e4",
  null
  
)

export default component.exports